// extracted by mini-css-extract-plugin
export default {"pageSelectorDIV":"Paginator_pageSelectorDIV__6R4Px","activePageSelector":"Paginator_activePageSelector__yIvnf"};